import React from "react";
import { FormattedMessage } from "react-intl";

interface Props {
  confirm: () => void;
}

export const SaveQuestions: React.FC<Props> = ({ confirm }) => {
  return (
    <div className="flex w-full h-full divide-y-2 divide-gray-300 overflow-auto">
      <div className="self-center w-2/3 h-5/6 mx-auto p-4 border shadow-md text-brand-dark_blue">
        <div className="flex flex-col h-full">
          <div className="flex h-3/4">
            <div className="flex flex-col justify-evenly w-1/2">
              <div className="text-3xl">
                <FormattedMessage
                  id={"SaveQuestions.Header"}
                  defaultMessage="You are almost ready"
                />
              </div>
              <div>
                <FormattedMessage
                  id="SaveQuestions.Paragraph1"
                  defaultMessage="Please check that all information is correct. If you are not
                ready, don't worry. You can save data and continue later at your
                convenience."
                />
              </div>
              <div>
                <FormattedMessage
                  id="SaveQuestions.Paragrahp2"
                  defaultMessage="After saving questions, you can create a link for the
                registration-form!"
                />
              </div>
              <div>
                <FormattedMessage
                  id="SaveQuestions.Paragraph3"
                  defaultMessage="
                Before publishing the registration-form, you have to resolve all
                validation-errors found on the Validation-tab!"
                />
              </div>
            </div>
            <div className="h-full">
              <img
                className="h-full mx-auto"
                src={`${process.env.PUBLIC_URL}/img/8055.jpg`}
                alt={`save_image`}
              />
            </div>
          </div>

          <div className="p-6">
            <button
              className="bg-blue-400 hover:bg-brand-blue font-thin text-brand-white py-2 px-4 rounded m-5"
              onClick={() => confirm()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveQuestions;
